<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Dedicated to my parents, Mildred and John, and grandparents, Fanny and Benson. They taught me to pray, read and write and encouraged me to never stop.</p>
<p class="block_"> </p>
<p class="block_2">To my friend and mentor, my father, John, thank you for creating ‘my safe space’, especially the one in my head.</p>
<p class="block_"> </p>
<p class="block_2">To Victoria, you were my only ally, back when I was unhappy. You are the best friend anyone could ever wish for.</p>
<p class="block_3" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?00ae0c38